module.exports = __webpack_public_path__ + "img/delete-filters.c5e28cb9.svg";